module.exports = __webpack_public_path__ + "static/media/empty02_retainer_anim.45120c1d.svg";